import { useEffect, useState } from "react";
import Api from "../../services/api";
import { NFTExport } from "../../models/exports";
import { useGetWalletNFTs } from "./useGetWalletNFTs";
import { useGetFractionalNFTs } from "./useGetFractionalNFTs";

export const useGetCombinedNFTs = (address: string) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>();
  const [combinedNFTs, setCombinedNFTs] = useState<NFTExport[]>();
  const [bothLoaded, setBothLoaded] = useState<boolean>(false);

  const [fractionalNFTs, fractionalLoading, fractionalError] =
    useGetFractionalNFTs(address);
  const [walletNFTs, walletLoading, walletError] = useGetWalletNFTs(address);

  const api = new Api();

  useEffect(() => {
    if (!fractionalLoading && !walletLoading) {
      setBothLoaded(true);
    }
  }, [fractionalLoading]);

  useEffect(() => {
    if (!fractionalLoading && !walletLoading) {
      setBothLoaded(true);
    }
  }, [walletLoading]);

  useEffect(() => {
    if (bothLoaded) {
      if (!walletError && !fractionalError) {
        const combined = walletNFTs.concat(fractionalNFTs);
        setCombinedNFTs(combined);
        setLoading(false);
      } else {
        console.log("Wallet Error: ", walletError);
        console.log("Fractional Error: ", fractionalError);
        setLoading(false);
      }
    }
  }, [bothLoaded]);

  return [combinedNFTs, loading, error];
};
